import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, hasAtLeastOneRequiredAction, NO_ACCESS_MESSAGE } from "utils/access";
import { Action } from "types/generated";

const UPDATE_INTENT_PROJECT_CONFIG_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.IntentProjectConfigUpdate,
];

/**
 * Hook that returns a function to check if the current user can update config in an intent project.
 * @returns Function that takes a spaceId and returns AccessResult
 */
const useCanUpdateIntentProjectConfig = (): ((spaceId?: string) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (spaceId) => {
      if (viewer.admin) {
        return { result: true };
      }

      if (!spaceId) {
        return { result: false };
      }

      const hasAccess = hasAtLeastOneRequiredAction(
        UPDATE_INTENT_PROJECT_CONFIG_ACCESS_TYPES,
        viewer,
        spaceId
      );

      if (hasAccess) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanUpdateIntentProjectConfig;
